import { makeStyles } from '@fluentui/react-components';

export const useManageAccessDialogStyles = makeStyles({
    surfaceBg: {
        backgroundColor: 'rgb(242 241 238)',
    },
    actionsCell: {
        justifyContent: 'flex-end',
    },
    deleteIcon: {
        color: 'black',
    },
});
